/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AnswerRequest { 
    /**
     * The waiting tool call: `pi.live.tools[i].taskId` of the slot whose `details.question` is set.
     */
    taskId: number;
    /**
     * The pause this answer is for: `pi.live.tools[i].details.pauseSeq`. An answer to a pause the call already left is 409 `already_answered`; one to a pause it never reached is 410.
     */
    pauseSeq: number;
    action: AnswerRequest.ActionEnum;
    /**
     * Form fields for `accept` (an approval is `{approved: true}`).
     */
    content?: object;
}
export namespace AnswerRequest {
    export type ActionEnum = 'accept' | 'decline' | 'cancel';
    export const ActionEnum = {
        Accept: 'accept' as ActionEnum,
        Decline: 'decline' as ActionEnum,
        Cancel: 'cancel' as ActionEnum
    };
}


